import React, { useMemo } from 'react';
import { useGenerateQRCode } from './useGenerateQRCode';

const QRCodeDisplay = ({
  email,
  width = 247,
  className = '',
  onGenerated,
  onError,
  showLoading = true,
  showError = true,
  loadingText = 'Generating QR code...',
  errorText = 'Failed to generate QR code',
  alt = 'QR Code',
}: QRCodeDisplayProps) => {
  const qrOptions = useMemo(() => ({ width }), [width]);
  const { qrDataURL, isGenerating, error } = useGenerateQRCode(email, qrOptions, onGenerated, onError);

  if (isGenerating && showLoading) {
    return (
      <div className={`qr-loading ${className}`}>
        <p>{loadingText}</p>
      </div>
    );
  }

  if (error && showError) {
    return (
      <div className={`qr-error ${className}`}>
        <p>{error || errorText}</p>
      </div>
    );
  }

  if (qrDataURL && !isGenerating) {
    return (
      <div className={`qr-code-container ${className}`}>
        <img src={qrDataURL} alt={alt} className="qr-code-image" />
      </div>
    );
  }

  return null;
};

export default QRCodeDisplay;

interface QRCodeDisplayProps {
  email: string;
  width?: number;
  className?: string;
  onGenerated?: (dataURL: string) => void;
  onError?: (error: string) => void;
  showLoading?: boolean;
  showError?: boolean;
  loadingText?: string;
  errorText?: string;
  alt?: string;
}
